import React from "react";
import { Col, Row, Space } from 'antd';
import AdnSaveButton from "../adnSaveButton/AdnSaveButton";
import AdnCancelButton from "../adnCancelButton/AdnCancelButton";

const AdnFormOptions = ({ handleCancel, readOnly, loading, canceltext }) => {
    return (
        <Row justify="end">
            <Space>
                <Col>
                    <AdnCancelButton onClick={handleCancel} text={canceltext}/>
                </Col>
                <Col>
                    {readOnly || <AdnSaveButton loading={loading} />}
                </Col>
            </Space>
        </Row>
    );
};

export default AdnFormOptions;
